import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaDocumentosCfdiConfiguracionItem', {
    template: template,
    controller: NominasNominaDocumentosCfdiConfiguracionItemComponent,
    bindings: {
      data: '<',
      onChange: '&',
    },
    require: {
      lista: '^nominasNominaDocumentosCfdiConfiguracionLista',
    },
  })

function NominasNominaDocumentosCfdiConfiguracionItemComponent() {
  let $ctrl = this
  $ctrl.seleccionar = seleccionar
  $ctrl.filtrarArea = filtrarArea
  $ctrl.filtrarDepartamento = filtrarDepartamento
  $ctrl.filtrarEstado = filtrarEstado

  function seleccionar(key) {
    $ctrl.data[key] = !$ctrl.data[key]
    $ctrl.onChange()
  }

  function filtrarArea(area) {
    $ctrl.lista.filtro_area = $ctrl.lista.filtro_area === area ? '' : area
    $ctrl.lista.filtrar()
  }

  function filtrarDepartamento(departamento) {
    $ctrl.lista.filtro_departamento = $ctrl.lista.filtro_departamento === departamento ? '' : departamento
    $ctrl.lista.filtrar()
  }

  function filtrarEstado(estado) {
    $ctrl.lista.filtro_estado = $ctrl.lista.filtro_estado === estado ? '' : estado
    $ctrl.lista.filtrar()
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/documentos/cfdi/configuracion/item/component.js